module.exports = __webpack_public_path__ + "img/secure-off.342a4754.svg";